var EHDI = EHDI || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.GlowEffect = function (size) {
    EHDI.aka.Container.call(this);

    this.active = false;

    this.visual = new EHDI.aka.Sprite(EHDI.Assets.images["fx_firsttimeplay_glow"]);
    this.visual.anchor.set(0.5, 0.5);
    this.scale.x = size / this.visual.width;
    this.scale.y = size / this.visual.height;
    this.addChild(this.visual);

    this.speed = (360 * (Math.PI / 180)) / 10000;

    this.appear = function (score) {
        if (this.active) return;

        this.active = true;
    }

    this.disappear = function () {
        if (!this.active) return;

        this.active = false;
    }


    this.update = function (delta) {
        if (!this.active)
            return false;

        this.rotation += delta * this.speed;

        return false;
    }
}

EHDI.components.GlowEffect.prototype = Object.create(EHDI.aka.Container.prototype);